import React, { Component } from 'react'

export default class NotFound extends Component {
  render() {
    return (
        <div className='text-center mt-12'>
        <h1 className='text-5xl text-[#F89A1F] mb-3'>404</h1>
        <h2>Page Not Found</h2>
        <p className='text-sm lg:text-xl'>Oops! The page you are looking for doesn't exist.</p>
      </div>
    )
  }
}
